import React, { useState } from 'react';
import { Form, Button, Message, Segment, Header } from 'semantic-ui-react';
import axiosInstance from '../../lib/auth/axiosApi';

const MonarchCredentials = ({ onCredentialsSaved }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mfaSecret, setMfaSecret] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    setSuccessMessage('');

    try {
      const response = await axiosInstance.post('/monarch/credentials/', {
        email,
        password,
        mfa_secret: mfaSecret
      });

      if (response.data.success) {
        setSuccess(true);
        const accountCount = response.data.accounts_found || 0;
        setSuccessMessage(`Connected successfully! Found ${accountCount} account${accountCount !== 1 ? 's' : ''}.`);
        setEmail('');
        setPassword('');
        setMfaSecret('');
        if (onCredentialsSaved) {
          onCredentialsSaved();
        }
      } else {
        setError(response.data.message || 'Failed to save credentials');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.response?.data?.error || 'Failed to save credentials';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Segment>
      <Header as="h3">Connect Monarch Money Account</Header>
      <Form onSubmit={handleSubmit} loading={loading}>
        <Form.Field>
          <label>Monarch Money Email</label>
          <input
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Field>
        <Form.Field>
          <label>Monarch Money Password</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </Form.Field>
        <Form.Field>
          <label>MFA Secret Key (Optional)</label>
          <input
            type="password"
            placeholder="Two-factor secret key from Monarch settings"
            value={mfaSecret}
            onChange={(e) => setMfaSecret(e.target.value)}
          />
          <small style={{ color: '#666' }}>
            Go to Monarch Settings → Security → Enable MFA → copy the "Two-factor text code"
          </small>
        </Form.Field>
        <Button type="submit" primary disabled={loading}>
          {loading ? 'Validating Credentials...' : 'Connect Account'}
        </Button>
      </Form>
      
      {error && (
        <Message negative>
          <Message.Header>Error</Message.Header>
          <p>{error}</p>
        </Message>
      )}
      
      {success && (
        <Message positive>
          <Message.Header>Success!</Message.Header>
          <p>{successMessage || 'Your Monarch Money account has been connected successfully.'}</p>
        </Message>
      )}
    </Segment>
  );
};

export default MonarchCredentials;